import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { isAdmin } from '../utils/roles';

export const Route = createFileRoute('/settings/cost-groups')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!isAdmin(user?.role)) {
      throw redirect({
        to: '/project-settings/employee-project-models',
      });
    }
  },
  component: () => <Outlet />,
});
